const hostedUiDomain = process.env.REACT_APP_COGNITO_HOSTED_UI_DOMAIN;

const normaliseUrl = (url) => {
  if (!url) return "";
  return url.endsWith("/") ? url : `${url}/`;
};

const runtimeOrigin =
  typeof window !== "undefined" && window?.location?.origin
    ? normaliseUrl(window.location.origin)
    : "";

const redirectSignIn =
  normaliseUrl(process.env.REACT_APP_OAUTH_REDIRECT_SIGNIN) || runtimeOrigin;
const redirectSignOut =
  normaliseUrl(process.env.REACT_APP_OAUTH_REDIRECT_SIGNOUT) || runtimeOrigin;

const oauthConfig =
  hostedUiDomain && redirectSignIn && redirectSignOut
    ? {
        domain: hostedUiDomain,
        scope: ["email", "openid", "profile"],
        redirectSignIn,
        redirectSignOut,
        responseType: "code",
      }
    : undefined;

const awsConfig = {
  aws_project_region: process.env.REACT_APP_AWS_PROJECT_REGION,
  aws_cognito_region: process.env.REACT_APP_AWS_COGNITO_REGION,
  aws_user_pools_id: process.env.REACT_APP_AWS_USER_POOLS_ID,
  aws_user_pools_web_client_id: process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID,
  mandatorySignIn: process.env.REACT_APP_MANDATORY_SIGN_IN === "true",
  ...(oauthConfig
    ? {
        oauth: oauthConfig,
        aws_cognito_social_providers: ["GOOGLE"],
      }
    : {}),
  api_url_get_menu: process.env.REACT_APP_API_URL_GET_MENU,
  api_url_create_business: process.env.REACT_APP_API_URL_CREATE_BUSINESS,
  api_url_ai_import: process.env.REACT_APP_API_URL_AI_IMPORT,
  api_url_presign_logo: process.env.REACT_APP_API_URL_PRESIGN_LOGO,
  api_url_get_order: process.env.REACT_APP_API_URL_GET_ORDER,
  api_url_delete_menu: process.env.REACT_APP_API_URL_DELETE_MENU,
  api_url_upgrade: process.env.REACT_APP_API_URL_UPGRADE,
  api_url_manage_slug: process.env.REACT_APP_API_URL_MANAGE_SLUG,
  api_url_frontend_proxy: process.env.REACT_APP_API_URL_FRONTEND_PROXY,
  api_url_integrations_key: process.env.REACT_APP_API_URL_INTEGRATIONS_KEY,
  api_url_secure_menu: process.env.REACT_APP_API_URL_SECURE_MENU,
  api_url_booking_schedules: process.env.REACT_APP_API_URL_BOOKING_SCHEDULES,
  public_base_url: process.env.REACT_APP_PUBLIC_BASE_URL,
  menu_base_url: process.env.REACT_APP_MENU_BASE_URL,
  main_marketing_domain: process.env.REACT_APP_MAIN_MARKETING_DOMAIN,
  ltd_sale_start: process.env.REACT_APP_LTD_SALE_START,
  ltd_sale_end: process.env.REACT_APP_LTD_SALE_END,
};

export default awsConfig;
